import { atom } from 'jotai';
import { CuboidClass, LabellingCuboid } from '@/types';
import {
  GetStructureLocationsForAssetLabellingDataLoaderQuery,
  GetAllLabelAnnotationsQuery,
  LabelClass,
} from '@/__generated__/graphql';
import { GetStructureForAssetLabellingQuery } from '@/__generated__/graphql';
import { StateMap } from '@/utils/stateMap';
import { StyledCuboid } from '@/modules/cuboids/types';
import { Number3 } from '@fabric-web/3d-viewer';

export const structure = atom<GetStructureForAssetLabellingQuery['structure'] | undefined>(
  undefined
);

export const locations = atom<
  GetStructureLocationsForAssetLabellingDataLoaderQuery['allLocations'] | undefined
>(undefined);

export const labelClassById = atom<
  { [id: string]: LabelClass & { isVisible: boolean } } | undefined
>(undefined);

export const labelAnnotations = atom<
  GetAllLabelAnnotationsQuery['allLabelAnnotations'] | undefined
>(undefined);

export const cuboidClassById = atom<{ [id: string]: CuboidClass } | undefined>(undefined);

export const defaultCuboidClassId = atom<string | undefined>(undefined);

// 3d-viewer options

export const showViewpoints = atom<boolean>(false);

export const showZoneBoundaries = atom<boolean>(false);

export const showNeighbouringZones = atom<boolean>(false);

export const currentCuboid = atom<StyledCuboid<LabellingCuboid> | undefined>(undefined);

export const cuboids = atom<StateMap<string, LabellingCuboid>>(
  new StateMap<string, LabellingCuboid>()
);

export const cuboidResizeStep = atom<Number3>([0.001, 0.001, 0.001]);
